import { BrowserRouter, Route, Routes } from "react-router-dom"
import Dashboard from "../backend/dashboard";
import Parametres from "../backend/parametres";
import StatutIndex from "../backend/statuts";
import Login from "../backend/auth/login";
import RoleIndex from "../backend/roles";
import TypesevaluationsIndex from "../backend/typesevaluations";
import UserCreate from "../backend/users/create";
import UserIndex from "../backend/users";
import UserEdit from "../backend/users/edit";
import ClassesIndex from "../backend/classe";
import HabilitationCreate from "../backend/habilitations/create";
import HabilitationEdit from "../backend/habilitations/edit";
import HabilitationIndex from "../backend/habilitations";
import EtablissementCreate from "../backend/etablissements/create";
import EtablissementIndex from "../backend/etablissements";
import EtablissementEdit from "../backend/etablissements/edit";
import SiteCreate from "../backend/sites/create";
import SiteIndex from "../backend/sites";
import SiteEdit from "../backend/sites/edit";
import CustomersDemo from "../backend/template";
import ClassesOptionsIndex from "../backend/classesoptions";
import MatieresIndex from "../backend/matieres";
import EnseignantCreate from "../backend/enseignants/create";
import EnseignantIndex from "../backend/enseignants";
import EnseignantEdit from "../backend/enseignants/edit";
import TypesinscriptionsIndex from "../backend/typesinscriptions";
import CategoriesgrillestarifairesIndex from "../backend/categoriesgrillestarifaires";
import GrillestarifairesIndex from "../backend/grillestarifaires";
import TranchesscolaritesIndex from "../backend/tranchesscolarites";
import CalendriesEvaluationsIndex from "../backend/calendriersevaluations";
import CivilitesIndex from "../backend/civilites";
import ListeInscrits from "../backend/inscriptions/listeInscrits";
import InscriptionCreate from "../backend/inscriptions/create";
import GrillestarifairesCreate from "../backend/grillestarifaires/create";
import GrillestarifairesEdit from "../backend/grillestarifaires/edit";
import ApprenantsIndex from "../backend/apprenants";
import ApprenantsEdit from "../backend/apprenants/edit";
import GenresIndex from "../backend/genres";
import NiveauxIndex from "../backend/niveaux";
import PeriodicitesScolairesIndex from "../backend/periodicitesscolaires";
import ModesPaiementsIndex from "../backend/modespaiements";
import SexeIndex from "../backend/sexes";
import TypecontratIndex from "../backend/typescontrats";
import StatutApprenantIndex from "../backend/statutapprenants";
import AnneesacademiquesIndex from "../backend/anneesacademiques";
import DetailsInscrit from "../backend/inscriptions/detailsInscrit";
import CoursCreate from "../backend/cours/create";
import CoursEdit from "../backend/cours/edit";
import CoursIndex from "../backend/cours";
import DevoirsIndex from "../backend/devoirs";
import DevoirsCreate from "../backend/devoirs/create";
import DevoirsEdit from "../backend/devoirs/edit";
import LiensParentauxIndex from "../backend/liensparentaux";
import EmploidutempsEnseignant from "../backend/emploidutemps/emploidutempsEnseignants";
import EmploidutempsClasse from "../backend/emploidutemps/emploidutempsClasse";
import ProgrammesevaluationsIndex from "../backend/programmesevaluations";
import ProgrammesevaluationsCreate from "../backend/programmesevaluations/create";
import ProgrammesevaluationsEdit from "../backend/programmesevaluations/edit";
import NotesCreate from "../backend/notes/create";
import NotesIndex from "../backend/notes";

const myroutes = {
    homepage: '/homepage',
    dashboard: '/admin/dashboard',
    parametres: '/admin/parametres',
    template: '/template',

    //statuts
    statuts_index: '/admin/statuts/index',

     //emploi du temps enseignants
     emploidutemps_enseignants: '/admin/emploidutemps/emploidutemps_enseignants',

     //emploi du temps classes
     emploidutemps_classes: '/admin/emploidutemps/emploidutemps_classes',

    //Roles
    roles_index: '/admin/roles/index',

    //Sexes
    sexes_index: '/admin/sexes/index',

    //Types contrats
    typescontrats_index: '/admin/typescontrats/index',

    //Annes academiques
    anneesacademiques_index: '/admin/anneesacademiques/index',

    //notes et moyennes
    notes_index: '/admin/notes/index',
    notes_create: '/admin/notes/create',



    //Users
    users_create: '/admin/users/create',
    users_index: '/admin/users/index',
    users_edit: '/admin/users/edit',
    //Habilitations
    habilitations_create: '/admin/habilitations/create',
    habilitations_index: '/admin/habilitations/index',
    habilitations_edit: '/admin/habilitations/edit',

    //Types Evaluations
    typesevaluations_index: '/admin/typesevaluations/index',

    //Calendriers evaluations
    calendriersevaluations_create: '/admin/calendriersevaluations/create',
    calendriersevaluations_index: '/admin/calendriersevaluations/index',
    calendriersevaluations_edit: '/admin/calendriersevaluations/edit',


    //Categories grilles tarifaires
    categoriesgrillestarifaires_index: '/admin/categoriesgrillestarifaires/index',


    //Grilles tarifaires
    grillestarifaires_index: '/admin/grillestarifaires/index',
    grillestarifaires_create: '/admin/grillestarifaires/create',
    grillestarifaires_edit: '/admin/grillestarifaires/edit',

    //Programmes evaluations
    programmesevaluations_index: '/admin/ programmesevaluations/index',
    programmesevaluations_create: '/admin/ programmesevaluations/create',
    programmesevaluations_edit: '/admin/ programmesevaluations/edit',

     //devoirs
     devoirs_index: '/admin/devoirs/index',
     devoirs_create: '/admin/devoirs/create',
     devoirs_edit: '/admin/devoirs/edit',
 


    //matieres
    matieres_index: '/admin/matieres/index',

    //tranches scolarites
    tranchesscolarites_index: '/admin/tranchesscolarites/index',

    //Etablissements
    etablissements_create: '/admin/etablissements/create',
    etablissements_index: '/admin/etablissements/index',
    etablissements_edit: '/admin/etablissements/edit',

    //Sites
    sites_create: '/admin/sites/create',
    sites_index: '/admin/sites/index',
    sites_edit: '/admin/sites/edit',

    //Classes
    classes_index: '/admin/classes/index',

    //Classes Options
    classesoptions_index: '/admin/classesoptions/index',

    //Cours
    cours_create: '/admin/cours/create',
    cours_index: '/admin/cours/index',
    cours_edit: '/admin/cours/edit',


    //Types inscriptions
    typesinscriptions_index: '/admin/typesinscriptions/index',

    //Enseignants
    enseignants_create: '/admin/enseignants/create',
    enseignants_index: '/admin/enseignants/index',
    enseignants_edit: '/admin/enseignants/edit',

    //Civilites
    civilites_index: '/admin/civilites/index',

    //Genre
    genres_index: '/admin/genres/index',

    //Apprenants
    apprenants_index: '/admin/apprenants/index',
    apprenants_edit: '/admin/apprenants/edit',

    //Niveaux
    niveaux_index: '/admin/niveaux/index',

    //Periodicites
    periodicites_index: '/admin/periodicites/index',

    //Mode paiements
    modespaiements_index: '/admin/modespaiements/index',

    //Statuts apprenants
    statutsapprenants_index: '/admin/statutsapprenants/index',

    //authentification route
    login: '/',

    // gestion des inscriptions et réinscriptions
    inscriptions: '/admin/inscriptions/index',
    inscription_create: '/admin/inscriptions/create',
    inscription_details: '/admin/inscriptions/show',

    //Liens parentaux
    liensparentaux_index: '/admin/liensparentaux/index',
}

//export routes
export { myroutes }
export default function Webroute() {
    return (
        <BrowserRouter>
            <Routes>
                {/** Route de la page d'accueil principale */}
                {/*login */}
                <Route path={myroutes.template} element={<CustomersDemo />} />

                {/*login */}
                <Route path={myroutes.login} element={<Login />} />
                {/*Dashboard */}
                <Route path={myroutes.dashboard} element={<Dashboard />} />
                {/*Paramètres */}
                <Route path={myroutes.parametres} element={<Parametres />} />


                {/*Statuts */}
                <Route path={myroutes.statuts_index} element={<StatutIndex />} />

                {/*Emploi du temps enseignant */}
                <Route path={myroutes.emploidutemps_enseignants} element={<EmploidutempsEnseignant />} />


                 {/*Emploi du temps classe */}
                 <Route path={myroutes.emploidutemps_classes} element={<EmploidutempsClasse/>} />

                {/*Roles */}
                <Route path={myroutes.roles_index} element={<RoleIndex />} />

                {/*Sexes */}
                <Route path={myroutes.sexes_index} element={<SexeIndex />} />

                {/*Types contrats*/}
                <Route path={myroutes.typescontrats_index} element={<TypecontratIndex />} />

                {/*Annes academiques*/}
                <Route path={myroutes.anneesacademiques_index} element={<AnneesacademiquesIndex />} />

                {/***Notes et moyennes*/}
                <Route path={myroutes.notes_index} element={<NotesIndex/>} />
                <Route path={myroutes.notes_create} element={<NotesCreate />} />

                {/*Users */}
                <Route path={myroutes.users_create} element={<UserCreate />} />
                <Route path={myroutes.users_index} element={<UserIndex />} />
                <Route path={myroutes.users_edit} element={<UserEdit />} />

                {/*Habilitations */}
                <Route path={myroutes.habilitations_create} element={<HabilitationCreate />} />
                <Route path={myroutes.habilitations_index} element={<HabilitationIndex />} />
                <Route path={myroutes.habilitations_edit} element={<HabilitationEdit />} />

                {/*Etablissements */}
                <Route path={myroutes.etablissements_create} element={<EtablissementCreate />} />
                <Route path={myroutes.etablissements_index} element={<EtablissementIndex />} />
                <Route path={myroutes.etablissements_edit} element={<EtablissementEdit />} />

                {/*Sites */}
                <Route path={myroutes.sites_create} element={<SiteCreate />} />
                <Route path={myroutes.sites_index} element={<SiteIndex />} />
                <Route path={myroutes.sites_edit} element={<SiteEdit />} />

                {/*Types Evaluations */}
                <Route path={myroutes.typesevaluations_index} element={<TypesevaluationsIndex />} />

                {/*Calendriers evaluations */}
                <Route path={myroutes.calendriersevaluations_index} element={<CalendriesEvaluationsIndex />} />

                {/*Classes */}
                <Route path={myroutes.classes_index} element={<ClassesIndex />} />

                {/*Classes options */}
                <Route path={myroutes.classesoptions_index} element={<ClassesOptionsIndex />} />

              {/*Cours */}
                <Route path={myroutes.cours_create} element={<CoursCreate />} />
                <Route path={myroutes.cours_index} element={<CoursIndex />} />
                <Route path={myroutes.cours_edit} element={<CoursEdit />} />

                {/*Matieres */}
                <Route path={myroutes.matieres_index} element={<MatieresIndex />} />

                {/*tranches scolarites */}
                <Route path={myroutes.tranchesscolarites_index} element={<TranchesscolaritesIndex />} />

                {/*Types inscriptions */}
                <Route path={myroutes.typesinscriptions_index} element={<TypesinscriptionsIndex />} />

                {/*Categories grilles tarifaires */}
                <Route path={myroutes.categoriesgrillestarifaires_index} element={<CategoriesgrillestarifairesIndex />} />

                {/*Grilles tarifaires */}
                <Route path={myroutes.grillestarifaires_index} element={<GrillestarifairesIndex />} />
                <Route path={myroutes.grillestarifaires_create} element={<GrillestarifairesCreate />} />
                <Route path={myroutes.grillestarifaires_edit} element={<GrillestarifairesEdit />} />

                 {/*Programmes evaluations */}
                <Route path={myroutes.programmesevaluations_index} element={<ProgrammesevaluationsIndex/>} />
                <Route path={myroutes.programmesevaluations_create} element={<ProgrammesevaluationsCreate />} />
                <Route path={myroutes.programmesevaluations_edit} element={<ProgrammesevaluationsEdit />} />

                {/*Devoirs */}
                <Route path={myroutes.devoirs_index} element={<DevoirsIndex />} />
                <Route path={myroutes.devoirs_create} element={<DevoirsCreate />} />
                <Route path={myroutes.devoirs_edit} element={<DevoirsEdit />} />

                {/*Enseignants */}
                <Route path={myroutes.enseignants_create} element={<EnseignantCreate />} />
                <Route path={myroutes.enseignants_index} element={<EnseignantIndex />} />
                <Route path={myroutes.enseignants_edit} element={<EnseignantEdit />} />

                {/*Civilites */}
                <Route path={myroutes.civilites_index} element={<CivilitesIndex />} />
                {/*Gestion Inscription / Réinscription */}
                <Route path={myroutes.inscriptions} element={<ListeInscrits />} />
                <Route path={myroutes.inscription_create} element={<InscriptionCreate />} />
                <Route path={myroutes.inscription_details} element={<DetailsInscrit />} />

                {/*Apprenants */}
                <Route path={myroutes.apprenants_index} element={<ApprenantsIndex />} />

                {/*Genres */}
                <Route path={myroutes.genres_index} element={<GenresIndex />} />

                {/*Niveaux */}
                <Route path={myroutes.niveaux_index} element={<NiveauxIndex />} />

                {/*Periodicites */}
                <Route path={myroutes.periodicites_index} element={<PeriodicitesScolairesIndex />} />

                {/*Mode paiements */}
                <Route path={myroutes.modespaiements_index} element={<ModesPaiementsIndex />} />

                {/*Statuts apprenants */}
                <Route path={myroutes.statutsapprenants_index} element={<StatutApprenantIndex />} />

                {/*Liens parentaux */}
                <Route path={myroutes.liensparentaux_index} element={<LiensParentauxIndex />} />

            </Routes>
        </BrowserRouter>
    )
}